import { ACT_ROL_CHANGE } from "./ActionTypes";
import RolesService from "../provider/rol/RolService";
import {loading} from "./AppActions"

/*** ACTIONS ROLES ******/
export function actionGetRoles(succesCallback, errorCallback) {
	return (dispatch, getStore) => {
			// loading(true)(dispatch)
			RolesService.getRoles(getStore().app.app).then((response) => {
					dispatch({
							type:ACT_ROL_CHANGE,
							props: {rolList:response}
					})
					succesCallback&&succesCallback()
			}).catch(errorCallback)
			// .finally(()=>{loading(false)(dispatch)})
	};
}

export function actionGetRolesRedimidores(succesCallback, errorCallback) {
	return (dispatch, getStore) => {
			loading(true)(dispatch, getStore)
			RolesService.getRolesRedimidores(getStore().app.app).then((response) => {
          console.log("actionGetRolesRedimidores", response)
					dispatch({
							type:ACT_ROL_CHANGE,
							props: {rolesRedimidoresList:response}
					})
					succesCallback&&succesCallback()
			}).catch(errorCallback)
			.finally(()=>{loading(false)(dispatch, getStore)})
	};
}

export function actionSaveRol(rol, successCallback, errorCallback) {
  return (dispatch, getStore) => {
    	console.log("actionSaveRol ROL", rol)
      loading(true)(dispatch, getStore)
      RolesService.saveRol(getStore().app.app, rol).then(()=>{
        successCallback&&successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionDeleteRol(rol, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch,getStore)
      RolesService.deleteRol(getStore().app.app, rol).then((response) => {
        successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

/****** FIN ACTION ROLES +**********/


// WEBPACK FOOTER //
// ./src/actions/RolActions.js